// assets
import { IconHome  } from '@tabler/icons';

// constant
const icons = { IconHome  };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const dashboard = {
    id: 'dashboard',

    type: 'group',
    children: [
        {
            id: 'default',
            title: 'Dashboard',
            type: 'item',
            url: '/dashboard',
            icon: icons.IconHome ,
            breadcrumbs: true
        }
    ]
};

export default dashboard;
